import React, { useEffect } from "react";
import Common_Banner from "../common/common-banner/Common_Banner";
import { Accordion } from "react-bootstrap";
import "./FAQ.css";
import { useDispatch, useSelector } from "react-redux";
import {GetAllfaq} from "../../redux/aboutus";

const FAQ = () => {
  const faqData = [
    {
      id: "01",
      question: " What is included in the Online Career Assessment?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "02",
      question: "How does the Career Counselling process work?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "03",
      question: " Do you provide counselling support for parents?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "04",
      question: " Will I receive a detailed report?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: "05",
      question: "How can I make the payment?",
      answer:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
  ];


const dispatch = useDispatch();
const faq = useSelector(state => state?.aboutus?.faq);
 useEffect(() => {
    dispatch(GetAllfaq());
  }, [dispatch]);



  return (
    <section className="FAQ FAQ_div">
      <Common_Banner
        bannerImg="/assets/images/common-banner/blogs.png"
        title="FREQUENTLY ASKED QUESTIONS"
      />

      <div className="container">
        <div className="FAQ_section">
          <Accordion defaultActiveKey="0">
            {faq?.map((item, index) => (
              <Accordion.Item
                eventKey={index.toString()}
                key={item?.id}
                className="mb-3"
              >
                <Accordion.Header>
                  <span className="faq_number">{index+1}</span>
                  <span className="faq_question">{item?.questions}</span>
                </Accordion.Header>
                <Accordion.Body>{item?.answers}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
